const getUser = async email => {
	const requestOptions = {
		method: 'GET',
		redirect: 'follow',
	}

	try {
		const response = await fetch(
			`${process.env.REACT_APP_GET_USER_URL}/${email}`,
			requestOptions,
		)
		return response
	} catch (error) {
		console.error('error', error)
	}
}

export { getUser }
